/* ********* Getters ********* */
//DRAWER
export const GET_DRAWER = "drawer/DRAWER";
export const GET_NAVIGATIONS_DRAWER = "drawer/GET_NAVIGATIONS_DRAWER";
export const GET_DRAWER_ITEM_NAME = "drawer/DRAWER_ITEM_NAME";

/* ********* Mutations ********* */

//DRAWER
export const MUTATE_DRAWER = "drawer/MUTATE_DRAWER";
export const MUTATE_NAVIGATIONS_DRAWER = "drawer/MUTATE_NAVIGATIONS_DRAWER";
export const MUTATE_DRAWER_ITEM_NAME = "drawer/MUTATE_DRAWER_ITEM_NAME";

/* ********* Actions ********* */

//DRAWER
export const ACTION_DRAWER = "drawer/ACTION_DRAWER";
export const ACTION_NAVIGATIONS_DRAWER = "drawer/ACTION_NAVIGATIONS_DRAWER";
export const ACTION_DRAWER_ITEM_NAME = "drawer/ACTION_DRAWER_ITEM_NAME";

//STAKING
export const VIPStatus = {
  TRUE: "IS_TRUE",
  FALSE: "IS_FALSE"
};

export const SortDirection = {
  ASC: "ASC",
  DESC: "DESC"
};
export const TYPE_VALUE = {
  FLEXIBLE: 0,
  FIX: 1
};

export const Property = {
  DURATION: "duration",
  ACTIVE_APY: "activeAPY"
};

export const FiltersType = {
  MAX_PROFIT: "MAX_PROFIT",
  MIN_PROFIT: "MIN_PROFIT",
  MAX_TIME: "MAX_TIME",
  MIN_TIME: "MIN_TIME",
  VIP: "VIP",
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  TERMINATED: "TERMINATED",
  CANCELED: "CANCELED",
  FLEXIBLE: "FLEXIBLE",
  FIX: "FIX"
};

export const ShowPlansType = {
  MY_PLANS: "MY_PLANS",
  ALL_PLANS: "ALL_PLANS"
};

//INIT
export const init = {
  getters: {
    GET_INIT_DATA: "GET_INIT_DATA",
    GET_SUPPORT: "GET_SUPPORT"
  },

  mutations: {
    MUTATE_INIT_DATA: "MUTATE_INIT_DATA",
    MUTATE_SUPPORT_DATA: "MUTATE_SUPPORT_DATA"
  },

  actions: {
    SET_INIT_DATA: "SET_INIT_DATA",
    SET_SUPPORT_DATA: "SET_SUPPORT_DATA"
  }
};
export const userInfo = {
  getters: {
    GET_USER_INFO: "GET_USER_INFO"
  },

  mutations: {
    MUTATE_USER_INFO: "MUTATE_USER_INFO",
    MUTATE_GOOGLE_VERIFICATION: "MUTATE_GOOGLE_VERIFICATION",
    MUTATE_SMS_VERIFICATION: "MUTATE_SMS_VERIFICATION",
    MUTATE_DEFAULT_STRATEGY: "MUTATE_DEFAULT_STRATEGY",
    MUTATE_USERNAME: "MUTATE_USERNAME",
    MUTATE_MOBILE_NUMBER: "MUTATE_MOBILE_NUMBER",
    MUTATE_PERSONAL: "MUTATE_PERSONAL"
  },

  actions: {
    ACTION_USER_INFO: "ACTION_USER_INFO",
    SET_GOOGLE_VERIFICATION: "SET_GOOGLE_VERIFICATION",
    SET_SMS_VERIFICATION: "SET_SMS_VERIFICATION",
    SET_DEFAULT_STRATEGY: "SET_DEFAULT_STRATEGY",
    SET_USERNAME: "SET_USERNAME",
    SET_MOBILE_NUMBER: "SET_MOBILE_NUMBER",
    SET_PERSONAL: "SET_PERSONAL"
  }
};

export const marketUserInfo = {
  getters: {
    GET_USER_INFO: "GET_USER_INFO"
  },

  mutations: {
    MUTATE_USER_INFO: "MUTATE_USER_INFO"
  },

  actions: {
    ACTION_USER_INFO: "ACTION_USER_INFO"
  }
};
export const transfer = {
  getters: {
    GET_TRANSFER_TO_MARKET: "GET_TRANSFER_TO_MARKET"
  },

  mutations: {
    MUTATE_TRANSFER_TO_MARKET: "MUTATE_TRANSFER_TO_MARKET"
  },

  actions: {
    ACTION_TRANSFER_TO_MARKET: "ACTION_TRANSFER_TO_MARKET"
  }
};

export const auth = {
  getters: {
    GET_IS_AUTH: "GET_IS_AUTH",
    GET_ACCESS_TOKEN: "GET_ACCESS_TOKEN",
    GET_VALIDATION_REGEX: "GET_VALIDATION_REGEX"
  },

  mutations: {
    MUTATE_CHECK_IS_AUTH: "MUTATE_CHECK_IS_AUTH",
    MUTATE_ACCESS_TOKEN: "MUTATE_ACCESS_TOKEN",
    MUTATE_VALIDATION_REGEX: "MUTATE_VALIDATION_REGEX"
  },

  actions: {
    ACTION_CHECK_IS_AUTH: "ACTION_CHECK_IS_AUTH",
    ACTION_ACCESS_TOKEN: "ACTION_ACCESS_TOKEN",
    ACTION_VALIDATION_REGEX: "ACTION_VALIDATION_REGEX"
  }
};

export const market = {
  getters: {
    GET_AVAILABLE_MARKET_DATA: "GET_AVAILABLE_MARKET_DATA",
    GET_BASE_CURRENCIES_DATA: "GET_BASE_CURRENCIES_DATA",
    GET_FILTERED_MARKET_LIST: "GET_FILTERED_MARKET_LIST",
    GET_SELECTED_BASE_CURRENCY: "GET_SELECTED_BASE_CURRENCY",
    GET_TO_CURRENCY: "GET_TO_CURRENCY",
    GET_DEFAULT_TO_CURRENCY: "GET_DEFAULT_TO_CURRENCY"
  },

  mutations: {
    MUTATE_AVAILABLE_MARKET_DATA: "MUTATE_AVAILABLE_MARKET_DATA",
    MUTATE_BASE_CURRENCIES_DATA: "MUTATE_BASE_CURRENCIES_DATA",
    MUTATE_FILTERED_MARKET_LIST: "MUTATE_FILTERED_MARKET_LIST",
    MUTATE_SELECTED_BASE_CURRENCY: "MUTATE_SELECTED_BASE_CURRENCY",
    MUTATE_TO_CURRENCY: "MUTATE_TO_CURRENCY",
    MUTATE_DEFAULT_TO_CURRENCY: "MUTATE_DEFAULT_TO_CURRENCY"
  },

  actions: {
    SET_AVAILABLE_MARKET_DATA: "SET_AVAILABLE_MARKET_DATA",
    SET_BASE_CURRENCIES_DATA: "SET_BASE_CURRENCIES_DATA",
    SET_FILTERED_MARKET_LIST: "SET_FILTERED_MARKET_LIST",
    SET_SELECTED_BASE_CURRENCY: "SET_SELECTED_BASE_CURRENCY",
    SET_TO_CURRENCY: "SET_TO_CURRENCY",
    SET_DEFAULT_TO_CURRENCY: "SET_DEFAULT_TO_CURRENCY"
  }
};

export const secure = {
  getters: {
    GET_SECURE: "GET_SECURE"
  },

  mutations: {
    MUTATE_SECURE: "MUTATE_SECURE"
  },

  actions: {
    SET_SECURE: "SET_SECURE"
  }
};

export const currencies = {
  getters: {
    GET_CURRENCIES: "GET_CURRENCIES",
    GET_TOP_CURRENCIES: "GET_TOP_CURRENCIES"
  },

  mutations: {
    MUTATE_CURRENCIES: "MUTATE_CURRENCIES",
    MUTATE_TOP_CURRENCIES: "MUTATE_TOP_CURRENCIES"
  },

  actions: {
    SET_CURRENCIES: "SET_CURRENCIES",
    SET_TOP_CURRENCIES: "SET_TOP_CURRENCIES"
  }
};

export const orderListStep = {
  getters: {
    GET_ORDER_LIST_STEP: "GET_ORDER_LIST_STEP"
  },

  mutations: {
    MUTATE_ORDER_LIST_STEP: "MUTATE_ORDER_LIST_STEP"
  },

  actions: {
    SET_ORDER_LIST_STEP: "SET_ORDER_LIST_STEP"
  }
};

export const operations = {
  getters: {
    GET_OPERATION_QUERY_ISO: "GET_OPERATION_QUERY_ISO",
    GET_WALLET: "GET_WALLET",
    GET_BANK_CARD: "GET_BANK_CARD",
    GET_DEPOSIT_CURRENCIES: "GET_DEPOSIT_CURRENCIES",
    GET_WITHDRAW_CURRENCIES: "GET_WITHDRAW_CURRENCIES",
    GET_EXCHANGE_CURRENCIES: "GET_EXCHANGE_CURRENCIES",
    GET_TRANSFER_CURRENCIES: "GET_TRANSFER_CURRENCIES",
    GET_PROCESSING_ORDER: "GET_PROCESSING_ORDER",
    GET_ORDER_EXPIRATION_STATUS: "GET_ORDER_EXPIRATION_STATUS",
    GET_ORDER_STEP: "GET_ORDER_STEP",
    GET_CANCEL_ORDER_STEP: "GET_CANCEL_ORDER_STEP",
    GET_COUNTDOWN_STATUS: "GET_COUNTDOWN_STATUS"
  },

  mutations: {
    MUTATE_OPERATION_QUERY_ISO: "MUTATE_OPERATION_QUERY_ISO",
    MUTATE_WALLET: "MUTATE_WALLET",
    MUTATE_BANK_CARD: "MUTATE_BANK_CARD",
    MUTATE_DEPOSIT_CURRENCIES: "MUTATE_DEPOSIT_CURRENCIES",
    MUTATE_WITHDRAW_CURRENCIES: "MUTATE_WITHDRAW_CURRENCIES",
    MUTATE_EXCHANGE_CURRENCIES: "MUTATE_EXCHANGE_CURRENCIES",
    MUTATE_TRANSFER_CURRENCIES: "MUTATE_TRANSFER_CURRENCIES",
    MUTATE_PROCESSING_ORDER: "MUTATE_PROCESSING_ORDER",
    MUTATE_ORDER_EXPIRATION_STATUS: "MUTATE_ORDER_EXPIRATION_STATUS",
    MUTATE_ORDER_STEP: "MUTATE_ORDER_STEP",
    MUTATE_CANCEL_ORDER_STEP: "MUTATE_CANCEL_ORDER_STEP",
    MUTATE_COUNTDOWN_STATUS: "MUTATE_COUNTDOWN_STATUS"
  },

  actions: {
    SET_OPERATION_QUERY_ISO: "SET_OPERATION_QUERY_ISO",
    SET_WALLET: "SET_WALLET",
    SET_BANK_CARD: "SET_BANK_CARD",
    SET_DEPOSIT_CURRENCIES: "SET_DEPOSIT_CURRENCIES",
    SET_WITHDRAW_CURRENCIES: "SET_WITHDRAW_CURRENCIES",
    SET_EXCHANGE_CURRENCIES: "SET_EXCHANGE_CURRENCIES",
    SET_TRANSFER_CURRENCIES: "SET_TRANSFER_CURRENCIES",
    ACTION_PROCESSING_ORDER: "ACTION_PROCESSING_ORDER",
    ACTION_ORDER_EXPIRATION_STATUS: "ACTION_ORDER_EXPIRATION_STATUS",
    ACTION_ORDER_STEP: "ACTION_ORDER_STEP",
    ACTION_CANCEL_ORDER_STEP: "ACTION_CANCEL_ORDER_STEP",
    ACTION_COUNTDOWN_STATUS: "ACTION_COUNTDOWN_STATUS"
  }
};

export const order = {
  getters: {
    GET_ORDERS_DATA: "GET_ORDERS_DATA"
  },

  mutations: {
    MUTATE_ORDERS_DATA: "MUTATE_ORDERS_DATA",
    UPDATE_ORDERS_DATA: "UPDATE_ORDERS_DATA"
  },

  actions: {
    SET_ORDERS_DATA: "SET_ORDERS_DATA",
    UPDATE_ORDERS_DATA: "UPDATE_ORDERS_DATA"
  }
};

export const wallets = {
  getters: {
    GET_WALLETS: "GET_WALLETS",
    GET_WALLETS_SETTING: "GET_WALLETS_SETTING",
    GET_NEW_WALLETS: "GET_NEW_WALLETS",
    GET_CHECK_WALLETS: "GET_CHECK_WALLETS",
    GET_EXCHANGE_WALLETS: "GET_EXCHANGE_WALLETS",
    GET_MARKET_CONDITIONS_WALLETS: "GET_MARKET_CONDITIONS_WALLETS",
    GET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS:
      "GET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS"
  },

  mutations: {
    MUTATE_WALLETS: "MUTATE_WALLETS",
    MUTATE_WALLETS_SETTING: "MUTATE_WALLETS_SETTING",
    MUTATE_NEW_WALLETS: "MUTATE_NEW_WALLETS",
    MUTATE_CHECK_WALLETS: "MUTATE_CHECK_WALLETS",
    UPDATE_CHECK_WALLETS: "UPDATE_CHECK_WALLETS",
    MUTATE_EXCHANGE_WALLETS: "MUTATE_EXCHANGE_WALLETS",
    MUTATE_MARKET_CONDITIONS_WALLETS: "MUTATE_MARKET_CONDITIONS_WALLETS",
    MUTATE_OPEN_MODAL_MARKET_CONDITIONS_WALLETS:
      "MUTATE_OPEN_MODAL_MARKET_CONDITIONS_WALLETS"
  },

  actions: {
    SET_WALLETS: "SET_WALLETS",
    SET_WALLETS_SETTING: "SET_WALLETS_SETTING",
    SET_NEW_WALLETS: "SET_NEW_WALLETS",
    SET_CHECK_WALLETS: "SET_CHECK_WALLETS",
    UPDATE_CHECK_WALLETS: "UPDATE_CHECK_WALLETS",
    SET_EXCHANGES_WALLETS: "SET_EXCHANGES_WALLETS",
    SET_MARKET_CONDITIONS_WALLETS: "SET_MARKET_CONDITIONS_WALLETS",
    SET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS:
      "SET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS"
  }
};

export const tradingView = {
  getters: {
    GET_TRADING_VIEW_DATA: "GET_TRADING_VIEW_DATA"
  },

  mutations: {
    MUTATE_TRADING_VIEW_DATA: "MUTATE_TRADING_VIEW_DATA"
  },

  actions: {
    SET_TRADING_VIEW_DATA: "SET_TRADING_VIEW_DATA"
  }
};

export const buySellState = {
  getters: {
    GET_BUY_SELL_STATE: "GET_BUY_SELL_STATE"
  },

  mutations: {
    MUTATE_BUY_SELL_STATE: "MUTATE_BUY_SELL_STATE"
  },

  actions: {
    SET_BUY_SELL_STATE: "SET_BUY_SELL_STATE"
  }
};

export const notifications = {
  getters: {
    GET_NOTIFICATIONS: "GET_NOTIFICATIONS"
  },

  mutations: {
    MUTATE_NOTIFICATIONS: "MUTATE_NOTIFICATIONS",
    MUTATE_ADD_NOTIFICATIONS: "MUTATE_ADD_NOTIFICATIONS"
  },

  actions: {
    ACTION_NOTIFICATIONS: "ACTION_NOTIFICATIONS",
    ACTION_ADD_NOTIFICATIONS: "ACTION_ADD_NOTIFICATIONS"
  }
};

export const transactions = {
  getters: {
    GET_TRANSACTIONS_DRAWER: "GET_TRANSACTIONS_DRAWER",
    GET_TRANSACTIONS_DETAIL: "GET_TRANSACTIONS_DETAIL",
    GET_TRANSACTIONS_CATEGORY: "GET_TRANSACTIONS_CATEGORY",
    GET_TRANSACTIONS_ORDER: "GET_TRANSACTIONS_ORDER",
    GET_TRANSACTIONS_STATUS: "GET_TRANSACTIONS_STATUS",
    GET_TRANSACTIONS_STATUS_LIST: "GET_TRANSACTIONS_STATUS_LIST",
    GET_TRANSACTIONS_QUERY: "GET_TRANSACTIONS_QUERY",
    GET_TRANSACTIONS_OFFLINE: "GET_TRANSACTIONS_OFFLINE"
  },

  mutations: {
    MUTATE_TRANSACTIONS_DRAWER: "MUTATE_TRANSACTIONS_DRAWER",
    MUTATE_TRANSACTIONS_DETAIL: "MUTATE_TRANSACTIONS_DETAIL",
    MUTATE_TRANSACTIONS_CATEGORY: "MUTATE_TRANSACTIONS_CATEGORY",
    MUTATE_TRANSACTIONS_ORDER: "MUTATE_TRANSACTIONS_ORDER",
    MUTATE_TRANSACTIONS_STATUS: "MUTATE_TRANSACTIONS_STATUS",
    MUTATE_TRANSACTIONS_STATUS_LIST: "MUTATE_TRANSACTIONS_STATUS_LIST",
    MUTATE_TRANSACTIONS_QUERY: "MUTATE_TRANSACTIONS_QUERY",
    MUTATE_TRANSACTIONS_OFFLINE: "MUTATE_TRANSACTIONS_OFFLINE"
  },

  actions: {
    ACTION_TRANSACTIONS_DRAWER: "ACTION_TRANSACTIONS_DRAWER",
    ACTION_TRANSACTIONS_DETAIL: "ACTION_TRANSACTIONS_DETAIL",
    ACTION_TRANSACTIONS_CATEGORY: "ACTION_TRANSACTIONS_CATEGORY",
    ACTION_TRANSACTIONS_ORDER: "ACTION_TRANSACTIONS_ORDER",
    ACTION_TRANSACTIONS_STATUS: "ACTION_TRANSACTIONS_STATUS",
    ACTION_TRANSACTIONS_STATUS_LIST: "ACTION_TRANSACTIONS_STATUS_LIST",
    ACTION_TRANSACTIONS_QUERY: "ACTION_TRANSACTIONS_QUERY",
    ACTION_TRANSACTIONS_OFFLINE: "ACTION_TRANSACTIONS_OFFLINE"
  }
};

export const userInfoV4 = {
  getters: {
    GET_USER_INFO_V4: "GET_USER_INFO_V4"
  },

  mutations: {
    MUTATE_USER_INFO_V4: "MUTATE_USER_INFO_V4",
    MUTATE_GOOGLE_VERIFICATION: "MUTATE_GOOGLE_VERIFICATION",
    MUTATE_SMS_VERIFICATION: "MUTATE_SMS_VERIFICATION",
    MUTATE_DEFAULT_STRATEGY: "MUTATE_DEFAULT_STRATEGY",
    MUTATE_USERNAME: "MUTATE_USERNAME",
    MUTATE_MOBILE_NUMBER: "MUTATE_MOBILE_NUMBER",
    MUTATE_PERSONAL: "MUTATE_PERSONAL"
  },

  actions: {
    SET_USER_INFO_V4: "SET_USER_INFO_V4",
    SET_GOOGLE_VERIFICATION: "SET_GOOGLE_VERIFICATION",
    SET_SMS_VERIFICATION: "SET_SMS_VERIFICATION",
    SET_DEFAULT_STRATEGY: "SET_DEFAULT_STRATEGY",
    SET_USERNAME: "SET_USERNAME",
    SET_MOBILE_NUMBER: "SET_MOBILE_NUMBER",
    SET_PERSONAL: "SET_PERSONAL"
  }
};

export const userVerifyInfo = {
  getters: {
    GET_USER_VERIFY_INFO: "GET_USER_VERIFY_INFO"
  },

  mutations: {
    MUTATE_USER_VERIFY_INFO: "MUTATE_USER_VERIFY_INFO",
    MUTATE_PERSONAL_STATUS: "MUTATE_PERSONAL_STATUS",
    MUTATE_IMAGE_STATUS: "MUTATE_IMAGE_STATUS",
    MUTATE_MOBILE_STATUS: "MUTATE_MOBILE_STATUS",
    MUTATE_PHONE_STATUS: "MUTATE_PHONE_STATUS",
    MUTATE_EMAIL_STATUS: "MUTATE_EMAIL_STATUS",
    MUTATE_MOBILE_VERIFICATION: "MUTATE_MOBILE_VERIFICATION"
  },

  actions: {
    SET_USER_VERIFY_INFO: "SET_USER_VERIFY_INFO",
    SET_PERSONAL_STATUS: "SET_PERSONAL_STATUS",
    SET_IMAGE_STATUS: "SET_IMAGE_STATUS",
    SET_MOBILE_STATUS: "SET_MOBILE_STATUS",
    SET_PHONE_STATUS: "SET_PHONE_STATUS",
    SET_EMAIL_STATUS: "SET_EMAIL_STATUS",
    SET_MOBILE_VERIFICATION: "SET_MOBILE_VERIFICATION"
  }
};

export const account = {
  getters: {
    IS_SIDEBAR_OPEN: "GET_ACCOUNT_SIDEBAR_STATE",
    SELECTED_TAB: "GET_ACCOUNT_SELECTED_TAB",
    SHOW_2FA: "GET_SHOW_2FA",
    SHOW_GOOGLE_AUTH: "GET_SHOW_GOOGLE_AUTH",
    SHOW_OTP_SETTING: "SHOW_OTP_SETTING"
  },

  actions: {
    SET_SIDEBAR: "SET_ACCOUNT_SIDEBAR_STATE",
    SET_TAB: "SET_ACCOUNT_TAB",
    SET_SHOW_2FA: "SET_SHOW_2FA",
    SET_SHOW_GOOGLE_AUTH: "SET_SHOW_GOOGLE_AUTH",
    SET_SHOW_OTP_SETTING: "SET_SHOW_OTP_SETTING"
  },

  mutations: {
    MUTATE_SIDEBAR: "MUTATE_ACCOUNT_SIDEBAR_STATE",
    MUTATE_TAB: "MUTATE_ACCOUNT_TAB",
    MUTATE_SHOW_2FA: "MUTATE_SHOW_2FA",
    MUTATE_SHOW_GOOGLE_AUTH: "MUTATE_SHOW_GOOGLE_AUTH",
    MUTATE_SHOW_OTP_SETTING: "MUTATE_SHOW_OTP_SETTING"
  }
};

export const identity = {
  getters: {
    IS_MODAL_OPEN: "IS_IDENTITY_MODAL_OPEN"
  },

  actions: {
    SET_MODAL: "SET_IDENTITY_MODAL"
  },

  mutations: {
    MUTATE_MODAL: "MUTATE_IDENTITY_MODAL"
  }
};

export const image = {
  getters: {
    IS_MODAL_OPEN: "IS_IMAGE_MODAL_OPEN"
  },

  actions: {
    SET_MODAL: "SET_IMAGE_MODAL"
  },

  mutations: {
    MUTATE_MODAL: "MUTATE_IMAGE_MODAL"
  }
};

export const mobile = {
  getters: {
    IS_MODAL_OPEN: "IS_MOBILE_MODAL_OPEN",
    MODAL_STEP: "MOBILE_MODAL_STEP"
  },

  actions: {
    SET_MODAL: "SET_MOBILE_MODAL",
    SET_STEP: "SET_MOBILE_STEP"
  },

  mutations: {
    MUTATE_MODAL: "MUTATE_MOBILE_MODAL",
    MUTATE_STEP: "MUTATE_MOBILE_STEP"
  }
};

export const phone = {
  getters: {
    IS_MODAL_OPEN: "IS_PHONE_MODAL_OPEN",
    MODAL_STEP: "PHONE_MODAL_STEP"
  },

  actions: {
    SET_MODAL: "SET_PHONE_MODAL",
    SET_STEP: "SET_PHONE_STEP"
  },

  mutations: {
    MUTATE_MODAL: "MUTATE_PHONE_MODAL",
    MUTATE_STEP: "MUTATE_PHONE_STEP"
  }
};

export const email = {
  getters: {
    IS_MODAL_OPEN: "IS_EMAIL_MODAL_OPEN",
    MODAL_STEP: "EMAIL_MODAL_STEP"
  },

  actions: {
    SET_MODAL: "SET_EMAIL_MODAL",
    SET_STEP: "SET_EMAIL_STEP"
  },

  mutations: {
    MUTATE_MODAL: "MUTATE_EMAIL_MODAL",
    MUTATE_STEP: "MUTATE_EMAIL_STEP"
  }
};

export const ticket = {
  getters: {
    categories: "GET_TICKET_CATEGORIES",
    hints: "GET_TICKET_HINTS",
    list: "GET_TICKET_LIST",
    paginatePages: "GET_TICKET_PAGINATE_PAGES",
    paginateItems: "GET_TICKET_PAGINATE_ITEMS",
    paginatePerPage: "GET_TICKET_PAGINATE_PER_PAGE"
  },

  actions: {
    setCategories: "SET_TICKET_CATEGORIES",
    setHints: "SET_TICKET_HINTS",
    setList: "SET_TICKET_LIST",
    add: "ADD_TICKET",
    setPaginatePages: "SET_TICKET_PAGINATE_PAGES",
    setPaginateItems: "SET_TICKET_PAGINATE_ITEMS",
    setPaginatePerPage: "SET_TICKET_PAGINATE_PER_PAGE"
  },

  mutations: {
    setCategories: "MUTATE_TICKET_CATEGORIES",
    setHints: "MUTATE_TICKET_HINTS",
    setList: "MUTATE_TICKET_LIST",
    add: "MUTATE_TICKET_ADD",
    setPaginatePages: "MUTATE_TICKET_PAGINATE_PAGES",
    setPaginateItems: "MUTATE_TICKET_PAGINATE_ITEMS",
    setPaginatePerPage: "MUTATE_TICKET_PAGINATE_PER_PAGE"
  }
};

export const userSetting = {
  getters: {
    GET_USER_SETTING: "GET_USER_SETTING"
  },

  mutations: {
    MUTATE_USER_SETTING: "MUTATE_USER_SETTING"
  },

  actions: {
    SET_USER_SETTING: "SET_USER_SETTING"
  }
};

export const marketExchange = {
  getters: {
    GET_CURRENT_COIN: "GET_CURRENT_COIN",
    GET_COIN_SCALES: "GET_COIN_SCALES",
    GET_SELECTED_PRICE: "GET_SELECTED_PRICE"
  },

  mutations: {
    MUTATE_CURRENT_COIN: "MUTATE_CURRENT_COIN",
    MUTATE_COIN_SCALES: "MUTATE_COIN_SCALES",
    MUTATE_SELECTED_PRICE: "MUTATE_SELECTED_PRICE"
  },

  actions: {
    SET_CURRENT_COIN: "SET_CURRENT_COIN",
    SET_COIN_SCALES: "SET_COIN_SCALES",
    SET_SELECTED_PRICE: "SET_SELECTED_PRICE"
  }
};

export const staking = {
  getters: {
    GET_SUBSCRIBE_PLANS: "GET_SUBSCRIBE_PLANS",
    GET_CALCULATOR_PLANS: "GET_CALCULATOR_PLANS"
  },

  mutations: {
    MUTATE_SUBSCRIBE_PLANS: "MUTATE_SUBSCRIBE_PLANS",
    MUTATE_CALCULATOR_PLANS: "MUTATE_CALCULATOR_PLANS"
  },

  actions: {
    SET_SUBSCRIBE_PLANS: "SET_SUBSCRIBE_PLANS",
    SET_CALCULATOR_PLANS: "SET_CALCULATOR_PLANS"
  }
};

export const corporate = {
  getters: {
    GET_ACCOUNTS_LIST: "GET_ACCOUNTS_LIST",
    GET_ACCOUNT_BY_UUID: "GET_ACCOUNT_BY_UUID"
  },

  mutations: {
    MUTATE_ACCOUNTS_LIST: "MUTATE_ACCOUNTS_LIST"
  },

  actions: {
    SET_ACCOUNTS_LIST: "SET_ACCOUNTS_LIST"
  }
};
